export const INITIALIZE_BOOKINGS = 'initialize-bookings';
const initializeBookings = () => ({ type: INITIALIZE_BOOKINGS });
export default initializeBookings;
